export const DatasetVariableTypeIdEnum = {
    STRING: 1,
    NUMBER: 2,
    SQL: 3,
    FIELD: 4,
    ENTITY: 5,
    ARRAY_MIXED: 6,
    ARRAY_STRING: 7
}